import axios from 'axios';
import { getUrls } from '@/util/urls';

const instanceAxios = axios.create({
  baseURL: getUrls().backendUrl
});

instanceAxios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config!.headers!.Authorization = token;
  }
  return config;
});

instanceAxios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      window.localStorage.removeItem('token');
      const pathName = window.location.pathname;
      if (pathName !== '/login') {
        window.sessionStorage.setItem('redirect', pathName);
        window.location.replace('/login');
      }
    }
    throw error;
  }
);

export default instanceAxios;
